/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetReservationInvoicePdfPathParameters } from 'api/actions/get-reservation-invoice-pdf/get-reservation-invoice-pdf-path-parameters';
import { GetReservationInvoicePdfResponse } from 'api/actions/get-reservation-invoice-pdf/get-reservation-invoice-pdf-response';

type GetReservationInvoicePdfQueryParameters = Record<string, any>;

/**
 * The path of the GetReservationInvoicePdf action.
 */
export const getReservationInvoicePdfActionPath = new SweetPath<keyof GetReservationInvoicePdfPathParameters>(
  '/reservations/{reservationId}/invoice/pdf',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetReservationInvoicePdf actions.
 */
export default function createGetReservationInvoicePdfAction(axios: AxiosInstance) {
  return function getReservationInvoicePdfAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetReservationInvoicePdfPathParameters;
    query?: GetReservationInvoicePdfQueryParameters;
  }) {
    const path = getReservationInvoicePdfActionPath.insert(parameters);

    return axios.get<GetReservationInvoicePdfResponse, GetReservationInvoicePdfResponse>(path, {
      params: query,
      headers,
      responseType: 'blob',
    });
  };
}
